/**
 * 筛选器值合并策略
 */
export enum FilterMergeStrategy {
  /**
   * 所有来源按优先级逐层合并
   * 高优先级在 field 粒度覆盖低优先级
   */
  MERGE_BY_PRIORITY = 'MERGE_BY_PRIORITY',
  /**
   * 取优先级最高的、返回非空结果的来源
   * 忽略其他来源
   */
  TAKE_HIGHEST = 'TAKE_HIGHEST',
}
